







































import { PropertyData, CustomerData } from '@beyondview/firebase-client-8';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import { MetaInfo } from 'vue-meta';

import UserRoleItem from '@/components/property/UserRoleItem.vue';

interface ComponentData {
	sortKeys: { [ key: string ]: string }
}

export default Vue.extend( {
	components: {
		UserRoleItem
	},
	props: {
		property: {
			type: Object as PropType<PropertyData>,
			required: true
		}
	},
	data(): ComponentData {
		return {
			sortKeys: {}
		};
	},
	head(): MetaInfo {
		return {
			title: `${this.$t( 'views.property.access.access' )}`
		};
	},
	computed: {
		...mapGetters( [ 'customer', 'userIsAdmin' ] ),
		agents(): string[] {
			const { sortKeys } = this;
			return Object.entries( this.customer.roles )
				.filter( ( [ _k, v ] ) => v === CustomerData.Role.Agent )
				.map( ( [ k, _v ] ) => k )
				.sort( ( a, b ) => ( sortKeys[ a ] || '' ).localeCompare( sortKeys[ b ] || '' ) );
		}
	},
	methods: {
		updateSortKeys( userId: string | number, $event: Event ) {
			this.$set( this.sortKeys, userId, $event );
		}
	}
} );
